import FolderApi from '@/api/folder'
import router from '@/router'
import cookie from '@/services/cookie'

const setFoldersAction = ({ commit }, payload) => {
  commit('setFolders', payload)
}
const getFoldersAction = async ({ commit }, params) => {
  const folders = await FolderApi.getFolders(params)
  if (folders && folders.length > 0) {
    cookie.setValue('hasFolder', true)
  }
  if (router.currentRoute.name === 'SharedWithMe') return
  commit('setFolders', folders)
  commit('setCurrentFolderDepth', null)
  commit('setBreadcrumbsMultipleLevelsArray', [])
  commit('setCurrentFolder', null)
}

const searchFoldersAction = async ({ commit }, params) => {
  const folders = await FolderApi.searchFolders(params)
  if (folders && folders.length > 0) {
    cookie.setValue('hasFolder', true)
  }
  commit('setFolders', folders)
  commit('setCurrentFolderDepth', null)
  commit('setBreadcrumbsMultipleLevelsArray', [])
  commit('setCurrentFolder', null)
}

const getShareFoldersAction = async ({ commit }, params) => {
  const folders = await FolderApi.getShareFolders(params)
  commit('setFolders', folders)
  commit('setCurrentFolderDepth', null)
  commit('setBreadcrumbsMultipleLevelsArray', [])
  commit('setCurrentFolder', null)
}

const getTeamFoldersAction = async ({ commit }, params) => {
  const folders = await FolderApi.getTeamFolders(params)
  if (router.currentRoute.name !== 'Team') return
  commit('setFolders', folders)
  commit('setCurrentFolder', null)
}

// sub-folders
const getSubFoldersAction = async ({ commit }, params) => {
  const { parentFolderId } = params
  const {
    folders,
    breadcrumbs,
    depth,
    hasShared,
    userId,
    ownerId,
    folderName,
    folderId,
  } = await FolderApi.getSubFolders(parentFolderId, params)
  if (router.currentRoute.name === 'SharedWithMe') return
  commit('setFolders', folders)
  commit('setBreadcrumbsMultipleLevelsArray', breadcrumbs)
  commit('setCurrentFolderDepth', depth)
  commit('setParentFolderHasShared', hasShared)
  commit('setCurrentFolder', {
    userId,
    ownerId,
    folderName,
    hasShared,
    folderId,
  })
}
const getShareSubFoldersAction = async ({ commit }, params) => {
  const { parentFolderId } = params
  const {
    folders, breadcrumbs, depth, permissions, userId, ownerId, folderName, folderId,
  } = await FolderApi.getShareSubFolders(parentFolderId, params)
  commit('setFolders', folders)
  commit('setBreadcrumbsMultipleLevelsArray', breadcrumbs)
  commit('setCurrentFolderDepth', depth)
  commit('setCurrentFolderPermission', permissions)
  commit('setCurrentFolder', {
    folderId,
    userId,
    ownerId,
    folderName,
    hasShared: true,
  })
}

export default {
  setFoldersAction,
  getFoldersAction,
  searchFoldersAction,
  getTeamFoldersAction,

  // sub-folders
  getSubFoldersAction,
  getShareFoldersAction,
  getShareSubFoldersAction,
}
